import { Hourglass } from "@phosphor-icons/react";
import { getTextPrimary, getTextSecondary } from "../../lib/styleHelpers";

export function WatchlistEmptyState({ filter, statusConfig, isDark }) {
  const isAll = filter === "all";
  return (
    <div className="p-12 text-center">
      <Hourglass size={48} className={`mx-auto mb-4 ${isDark ? "text-gray-600" : "text-gray-300"}`} />
      <h3 className={`text-lg font-bold mb-2 ${getTextPrimary(isDark)}`}>
        {isAll
          ? "No opportunities watchlisted yet"
          : `No ${statusConfig[filter]?.label.toLowerCase()} items`}
      </h3>
      <p className={`font-body text-sm ${getTextSecondary(isDark)}`}>
        {isAll
          ? "Click the star icon on any opportunity to add it to your watchlist"
          : "Try a different filter"}
      </p>
    </div>
  );
}
